import Scroller from 'vux/src/components/scroller/index.vue'


const pulldownDefaultConfig = {
content: '下拉刷新',
height: 40,
autoRefresh: false,
downContent: '下拉刷新',
upContent: '释放后刷新',
loadingContent: '正在刷新...',
clsPrefix: 'xs-plugin-pulldown-'
}

const pullupDefaultConfig = {
content: '上拉加载更多',
pullUpHeight: 60,
height: 40,
autoRefresh: false,
downContent: '释放后加载',
upContent: '上拉加载更多',
loadingContent: '加载中...',
clsPrefix: 'xs-plugin-pullup-'
}

export default {
name: 'video',
components:{
Scroller
},
data () {
return {
pulldownDefaultConfig: pulldownDefaultConfig,
pullupDefaultConfig: pullupDefaultConfig,
list: [],
page: 1,
vedioType:''
}
},
watch: {
$route (to, from) {
this.headerFlag = to.name
this.page = 1
this.list = []
if(this.$utils('type') == 'design') {
this.vedioType= '3D建模'
}else if (this.$utils('type') == 'print') {
this.vedioType= '3D打印'
}
else if (this.$utils('type') == 'software') {
this.vedioType= '3D小软件'
}
this.loadMore()
}
},
methods: {
getCookie(name) {
var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
if (arr = document.cookie.match(reg))
return unescape(arr[2]);
else
return null;
},
fetchData(cb) {
this.$request.post('/creativeVideo/listCreativeVideo',{
page:this.page,
rows:3,
videoType:this.vedioType
},).then(data => {
if(data.code == 0){
this.$nextTick(() => {
this.$refs.scrollerBottom.reset()
})
cb(data.obj.rows)
console.log(data)
}else{
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
this.$vux.loading.hide()
})
},
refresh() {
this.page = 1
this.fetchData(data => {
this.list = data
this.$refs.scrollerBottom.enablePullup()   
this.$refs.scrollerBottom.donePulldown()   
if (data.length < 10) {
this.$refs.scrollerBottom.disablePullup()
}
this.$vux.toast.show({
type: 'success',
text: '刷新成功'
})
})
this.page += 1
},
loadMore() {
this.fetchData(data => {
setTimeout(() => {
this.$vux.loading.hide()
}, 100);
this.$refs.scrollerBottom.enablePullup()
if (data.length < 10) {
this.$refs.scrollerBottom.disablePullup()
}
if(this.page == 1 && data.length == 0){
this.noData = true
this.$refs.scrollerBottom.disablePullup()
}else{
this.noData = false
}
this.list = this.list.concat(data)
this.$refs.scrollerBottom.donePullup()
this.page += 1
})
},
gotoInfo(item){
this.$router.push({
path:'/videoInfo',
query:{
videoId:item.id
}
})
},
},
computed: {

},
created() {
if(this.$utils('type') == 'design') {
this.vedioType= '3D建模'
}else if (this.$utils('type') == 'print') {
this.vedioType= '3D打印'
}
else if (this.$utils('type') == 'software') {
this.vedioType= '3D小软件'
}
this.loadMore()
},
mounted() {

},
}


// WEBPACK FOOTER //
// ./src/views/video/script.js